/*eslint-disable*/
import React from "react";
// nodejs library to set properties for components
import PropTypes from "prop-types";
// nodejs library that concatenates classes
import classNames from "classnames";
import { withStyles } from "@material-ui/core";

import footerStyle from "../../assets/jss/material-kit-react/components/footerStyle.jsx";
import manual from '../../assets/ІнструкціяФОП_Веб.doc'
import Button from "components/CustomButtons/Button.jsx";

function Footer({ ...props }) {
  const { classes, whiteFont } = props;
  const footerClasses = classNames({
    [classes.footer]: true,
    [classes.footerWhiteFont]: whiteFont
  });
  const aClasses = classNames({
    [classes.a]: true,
    [classes.footerWhiteFont]: whiteFont
  });
  return (
    <footer className={footerClasses}>
      <div className={classes.container}>
        <div className={classes.left}>
          <a
            href={manual}
            className={classNames(aClasses, classes.block)}
            // style={{color: "white"}}
            target="_blank"
            variant="contained"
            // color="primary"
          >
            Інструкція користувача
          </a>
            <span>
            В разі виникнення питань з приводу роботи сервісу пишіть на <a className={classNames(aClasses, classes.block)} href="mailto:callcenter@ioc.gov.ua">callcenter@ioc.gov.ua</a>
            {/* <a className={classNames(aClasses, classes.block)} href="tel:+380444941910">+38 (044) 494-19-10</a> */}
          </span>
       
           
         
        </div>
        <div className={classes.right}>
          &copy; {1900 + new Date().getYear()},
          &nbsp; 
          <a
            href="https://www.ioc.gov.ua/"
            className={aClasses}
            target="_blank"
          >
            ДП "ІОЦ Мінсоцполітики України"
          </a>
          
        </div>
      </div>
    </footer>
  );
}

Footer.propTypes = {
  classes: PropTypes.object.isRequired,
  whiteFont: PropTypes.bool
};

export default withStyles(footerStyle)(Footer);
